/**
 * TODO:  Clean API up by breaking down to multiple files, moving shared methods out
 */
import {ftAxios, ftAppBase} from './ftAxios'
import {
  setUser,
  requestClubSettingsRefresh,
  setClubSettings,
  setAppConfig,
  setStyles,
  setLoggingIn,
  setSessionExpired,
  setAppState,
  setClubSettingsCacheKey,
  buildMenu,
  // buildNavItems,
  // updateNavItems
} from '../store/actions'
import {isLocalDev, clubFromLocation, modeFromLocation} from '../util/helpers'
import moment from 'moment-timezone'
import {getEmptyUser} from '../store'
import axios from 'axios'

// var apiAcessToken // Used if client doesn't support localStorage
// var lastValidAccessToken // Used to backup last valid access token -- used for releasing record locks
var usedSk
var club
var clubZoneId = moment.tz.guess()
var currentUser
var serverTimeOffset = 0 // Offset between client's clock and server's
var recordLocks = {}
var apiVersion
var sessionExpPromptOpen = false
var nextVersionCheck = 0
var lastValidAccessToken = null
var lastMenuJson = null
var builtMenu = false
const versionCheckInterval = 60000 // every 1 minute

function _setClub (clubName) {
  club = clubName
}

function _club () {
  return club || clubFromLocation()
}

function _appMode () {
  return modeFromLocation()
}

function _loginUri () {
  return ftAppBase() + '/LoginPrompt?proshop&cn=' + _club() + (isLocalDev() ? '&localdev=' + window.location.hostname + ':' + window.location.port : '')
}

function _getApiAccessToken () {
  return _getApiAccessTokenFromLS()
}

/**
 * Only used to release locks on window close, etc.  If no token found, use last token we had.
 */
function _getLastActiveApiAccessToken () {
  return _getApiAccessTokenFromLS() || lastValidAccessToken
}

function _tokenStorageKey () {
  return 'ft-' + _appMode() + '-token_' + _club()
}

function _getApiAccessTokenFromLS () {
  var result = null
  if (localStorage) {
    result = localStorage.getItem(_tokenStorageKey())
    if (result) lastValidAccessToken = result // Store for use in releasing locks
  } else {
    console.warn('No API access token stored')
  }
  return result
}

function _setApiAccessToken (token) {
  if (localStorage) {
    localStorage.setItem(_tokenStorageKey(), token)
  }
}

function _clearApiAccessToken () {
  console.log('Clearing API Access Token')
  if (localStorage) {
    localStorage.removeItem(_tokenStorageKey())
  }
}

function _setLastStyles (styles) {
  if (localStorage) {
    localStorage.setItem(_tokenStorageKey() + '_styles', JSON.stringify(styles))
  }
}

function _getLastStyles () {
  var result = null
  if (localStorage) {
    result = localStorage.getItem(_tokenStorageKey() + '_styles')
    if (result) {
      try {
        return JSON.parse(result)
      } catch (e) {
        console.warn('Invalid styles JSON')
        return null
      }
    }
  }
  return null
}

function _setSkipResponseToken (value) {
  if (localStorage) {
    localStorage.setItem(_tokenStorageKey() + '_skipRT', JSON.stringify(value))
  }
}

function _getSkipResponseToken () {
  var result = false
  if (localStorage) {
    result = localStorage.getItem(_tokenStorageKey() + '_skipRT')
    if (result) {
      try {
        return JSON.parse(result)
      } catch (e) {
        console.warn('Invalid _skipRT JSON')
        return false
      }
    }
  }
  return false
}

function _setLastClubSettings (settings) {
  if (localStorage) {
    localStorage.setItem(_tokenStorageKey() + '_settings', JSON.stringify(settings))
  }
}

function _getLastClubSettings () {
  var result = null
  if (localStorage) {
    result = localStorage.getItem(_tokenStorageKey() + '_settings')
    if (result) {
      try {
        return JSON.parse(result)
      } catch (e) {
        console.warn('Invalid club setting JSON', result)
        return null
      }
    }
  }
  return null
}

function _getLastAppConfig () {
  var result = null
  if (localStorage) {
    result = localStorage.getItem(_tokenStorageKey() + '_config')
    if (result) {
      try {
        return JSON.parse(result)
      } catch (e) {
        console.warn('Invalid club config JSON', result)
        return null
      }
    }
  }
  return null
}

function _allOpenRecordLocks () {
  var locks = []
  for (var key in recordLocks) {
    locks.push(key)
  }
  return locks.length ? locks : null
}

function _releaseAllLocks () {
  var locks = _allOpenRecordLocks()
  if (locks) {
    console.warn('Release Locks on Window Close!', locks)
    const url = ftAppBase() + '/API'
    if (navigator.sendBeacon) {
      console.log('Using send Beacon')
      const commands = [{
        command: 'releaseLock',
        record_key: locks
      }]
      navigator.sendBeacon(url + '?method=GET&FtApiJWT=' + encodeURIComponent(_getLastActiveApiAccessToken()), JSON.stringify(commands))
    } else {
      console.log('Using XMLHttpRequest')
      var request = new XMLHttpRequest()
      request.open('GET', url + '?command=releaseLock&httperrors=true&record_key=' + encodeURIComponent(JSON.stringify(locks)) + '?', false)  // `false` makes the request synchronous -- needed for beforeunload
      request.withCredentials = true
      request.setRequestHeader('Authorization', 'Bearer ' + _getLastActiveApiAccessToken())
      request.send(null)
      if (request.status === 200) {
        recordLocks = {}
      }
    }
  }
}

window.addEventListener('beforeunload', _releaseAllLocks) // Some browsers work better with beforeunload
window.addEventListener('unload', _releaseAllLocks) // Some with unload

var _started = false

const apiInstanceMap = new WeakMap()

const _factory = function (options) {

  var _caller = this // Context of calling component
  var _callerRecordLocks = {}
  const notificationIcons = {
    WARNING: {icon: 'mdi-alert', color: 'warning'},
    INFO: {icon: 'mdi-information', color: 'success'},
    ERROR: {icon: 'mdi-alert-circle', color: 'error'},
    QUESTION: {icon: 'mdi-help-circle', color: 'primary'},
    default: {icon: undefined, color: undefined}
  }

  if (!_started) {
    // First load.  Set some stuff up.
    _started = true
    setTimeout(() => {
      const lastClubSettings = _getLastClubSettings()
      if (lastClubSettings) {
        // Use last used club settings until we get a chance to re-load
        setClubSettings(_caller.$store, lastClubSettings)
      }
      const lastAppConfig = _getLastAppConfig()
      if (lastAppConfig) {
        // Use last used club settings until we get a chance to re-load
        setAppConfig(_caller.$store, lastAppConfig)
        console.warn('Checking menu on start', _caller, this)
        _checkMenu(lastAppConfig)
      }
      const lastStyles = _getLastStyles()
      if (lastStyles && lastStyles.version === _caller.$store.getters.styles.version) {
        // Use last used styles until we get a chance to re-load
        setStyles(_caller.$store, lastStyles)
      } else if (lastStyles) {
        // Different version, but we'll keep the last app state
        setStyles(_caller.$store, {
          appMode: lastStyles.appMode
        })
      }
    }, 0)
  }

  /**
   * Return Public Methods
   */
  return {
    get: _get,
    put: _put,
    export: _export,
    delete: _delete,
    deleteWithConfirmation: _deleteWithConfirmation,
    release: _release,
    skLogin: _skLogin,
    loginUri: _loginUri,
    setClub: _setClub,
    getClub: () => {return _club()},
    logout: _logout,
    logoutPrompt: _logoutPrompt,
    $ftUser: _currentUser || {access: {}},
    access: (_currentUser || {}).access || {},
    foreteesLogin: _foreteesLogin,
    checkUser: _checkUser,
    timeOffset: serverTimeOffset,
    appVersion: process.env.VUE_APP_VERSION,
    checkVersion: _checkVersion,
    closeDialogs: _closeDialogs,
    clubMoment: _clubMoment,
    clubMomentTz: _clubMomentTz,
    clubZoneId: clubZoneId,
    tokenStorageKey: _tokenStorageKey,
    setLastStyles: _setLastStyles,
    setLastAppConfig: _setLastAppConfig,
    setLastClubSettings: _setLastClubSettings,
    checkSkLogin: _checkSkLogin,
    apiVersion: () => apiVersion || 'N/A',
    getGlobalAppState: _getGlobalAppState,
    setGlobalAppState: _setGlobalAppState,
    appMode: _appMode,
    setAccessToken: _setAccessToken,
    setUser: _setUser,
    setSkipResponseToken: _setSkipResponseToken,
    storageEvent: _storageEvent,
    openRecordLocks: _openRecordLocks,
    checkRecordLocks: _checkRecordLocks,
    lockUserAndScreen: _lockUserAndScreen,
    lockScreen: _lockScreen,
    requestClubSettingsRefresh: ()=>{requestClubSettingsRefresh(_caller.$store, true)}
  }

  function _lockUserAndScreen () {
    _setGlobalAppState({screenLocked: true, userLock: true})
  }

  function _lockScreen () {
    _setGlobalAppState({screenLocked: true})
  }

  // TODO: merge this with appState vuex store to reduce confusion and simplify use
  function _getGlobalAppState (skipStore) {
    var _default = {
      // Make sure anything you add here is also added to /ft-vue-core/store/modules/appState/index.js
      // These variables are persistent and synced across all open tabs.
      // Read them using [vueInstance].$ftAS.[property] for reactivity.
      // Write them using [vueInstance].$ftAPI().setGlobalAppState({[property]: [value], ..., ...}).
      v: 0.2, // increment this if you add properties, else we won't update existing stored values correctly
      loaded: true,
      key: null,
      lastUsers: [],
      allowScreenLock: false,
      screenLocked: false,
      userLock: false,
      lastActivity: Date.now(),
      jwt: null, // Restricted access JWT for terminal
    }
    var result = _default
    if (localStorage) {
      const json = localStorage.getItem(_tokenStorageKey() + '_state')
      if (json) {
        try {
          result = JSON.parse(json)
          if (result && result.loaded) {
            if (result.v !== _default.v) {
              for (var k in _default) {
                if (result[k] === undefined) {
                  result[k] = _default[k]
                }
              }
              result.v = _default.v
              if (!skipStore) _setGlobalAppState(result)
            }
            return result
          }
          console.warn('Invalid stored app state object', result, json)
        } catch (e) {
          console.warn('Invalid stored app state JSON', json)
        }
      }
      if (!skipStore) _setGlobalAppState(_default)
    }
    return _default
  }

  // TODO: merge this with appState vuex store to reduce confusion and simplify use
  function _setGlobalAppState (changes) {
    if (localStorage) {
      var appState = _getGlobalAppState(true)
      var hashChanges = false
      for (var k in changes) {
        if (JSON.stringify(appState[k]) !== JSON.stringify(changes[k])) {
          appState[k] = changes[k]
          hashChanges = true
        }
      }
      if (hashChanges) localStorage.setItem(_tokenStorageKey() + '_state', JSON.stringify(appState))
      setAppState(_caller.$store, changes)
    }
  }

  function _storageEvent (event) {
    if (event.key === _tokenStorageKey() + '_state') {
      // global app state has changed.  Update vuex
      setAppState(_caller.$store, _getGlobalAppState(true))
    }
  }

  function _setLastAppConfig (config) {
    if (localStorage) {
      localStorage.setItem(_tokenStorageKey() + '_config', JSON.stringify(config))
    }
  }

  function _checkMenu (config) {
    console.log('Checking config menu', config)
    const menuJson = JSON.stringify(config && config.menu)
    const needMenuUpdate = menuJson !== lastMenuJson
    lastMenuJson = menuJson
    if (needMenuUpdate) {
      console.warn('Building menu from server side config', config)
      buildMenu(_caller.$store, _caller)
      // buildNavItems(_caller)
      // updateNavItems(_caller)
    }
  }

  function _clubSettings () {
    return _caller.$store.getters.clubSettings
  }

  function _clubSettingCacheKey () {
    return _caller.$store.getters.appState.csCacheKey
  }

  function _clubSettingCacheReloadRequested () {
    return _caller.$store.getters.appState.csReloadReq
  }

  function _clubSettingKeys () {
    return Object.keys(_clubSettings())
  }

  function _checkVersion () {
    const now = Date.now()
    if (now >= nextVersionCheck) {
      console.warn('Checking for updates')
      nextVersionCheck = now + versionCheckInterval
      axios.get(isLocalDev() ? '/' : './')
        .then(function (response) {
          // handle success
          const htmlDoc = document.createElement('html')
          htmlDoc.innerHTML = response.data
          const versionEl = htmlDoc.querySelector('#app-version')
          if (versionEl) {
            const remoteVersion = versionEl.textContent
            console.log('version', process.env.VUE_APP_VERSION, remoteVersion)
            if (remoteVersion) {
              setAppState(_caller.$store, {
                updateAvailable: remoteVersion !== process.env.VUE_APP_VERSION,
                versionAvailable: remoteVersion
              })
            }
          }
        })
        .catch(function (error) {
          // handle error
          console.log('Error checking version', error)
        })
    }
  }

  /**
   * Convert supplied time to club's local time, or return club's current time, adjust for difference between client and server
   * @param {*} time
   * @param {*} tz
   */
  function _clubMomentTz (time, tz) {
    // console.log('Club Moment UTC offset', clubZoneId)
    var doOffset = false
    if (!time) {
      time = new Date().getTime()
      doOffset = true
    }
    if (typeof time === 'string') {
      const tzInDate = time.match(/^(.*)\[(.*)\]$/)
      if (tzInDate) {
        time = moment.tz(tzInDate[1], tzInDate[2]).toDate().getTime()
      } else if (tz) {
        time = moment.tz(time, tz).toDate().getTime()
      } else {
        time = moment(time).toDate().getTime()
      }
    }
    var clientTimeWOffset = doOffset ? time + serverTimeOffset * 1000 : time
    return moment(clientTimeWOffset).tz(clubZoneId)
  }

  /**
   * Convert supplied time to club's local time, or return club's current time, adjust for difference between client and server
   * @param {*} time
   * @param {*} tz
   */
  function _clubMoment (time, tz) {
    return moment(_clubMomentTz(time, tz).format('YYYY-MM-DD HH:mm:ss.SSSSSSSSS'))
  }

  /**
   * Get record(s)
   * @param {*} options
   * @param {*} axiosOptions
   */
  function _get (options, axiosOptions, skipLoading) {
    if (Array.isArray(options)) {
      // Multi-get
      _getMulti(options, axiosOptions, skipLoading)
      return
    }
    // Single-get
    if (!skipLoading) _setLoading(options)
    console.log('ftAPI.get', options, axiosOptions)
    var params = _buildParams(options)
    axiosOptions = _getAxiosOptions(axiosOptions, {})
    axiosOptions.params = params
    ftAxios.get('API', axiosOptions).then((response) => {
      // HTTP 200 OK received indicating no errors encountered
      _response(options, response)
    }, (err) => {
      // Error
      _error(options, err, 'get', axiosOptions)
    })
  }

  function _getMulti (options, axiosOptions, skipLoading) {
    console.log('ftAPI.getMulti', options, axiosOptions)
    // Multi-get
    const commands = []
    const paramOpts = {}
    for (var i in options) {
      const option = options[i]
      if (!skipLoading) _setLoading(option)
      const command = _buildParams(option, undefined, true)
      delete command.httperrors
      if (command.addtoken) paramOpts.addtoken = true
      delete command.addtoken
      // command.request_id = parseInt(i, 10)
      // console.log('GetMulti', i, command)
      commands.push(command)
    }
    const params = _buildParams({params: paramOpts}, 'GET', true)
    axiosOptions = _getAxiosOptions(axiosOptions, {})
    axiosOptions.params = params
    ftAxios.post('API', commands, axiosOptions).then((response) => {
      // HTTP 200 OK received indicating no errors encountered
      const ftresponse = response.data
      const multiResponse = ftresponse.results
      for (var i in options) {
        var option = options[i]
        var result = multiResponse[i]
        ftresponse.result_total_size = ftresponse.result_counts && ftresponse.result_counts[i] || undefined
        ftresponse.result = result
        _response(option, response)
      }
    }, (err) => {
      // Error
      const ftResponse = _ftErrorResponse(err)
      var didError = false
      if (ftResponse) {
        // foretees error
        if (ftResponse.error_request_id) {
          // Error from multi response
          let i = parseInt(ftResponse.error_request_id, 10)
          if (options[i]) {
            _error(options[i], err, 'get', axiosOptions, null, options)
            didError = true
          }
        }
        let i = ftResponse.batch_index
        if (!didError && i !== null && i !== undefined) {
          if (options[i]) {
            _error(options[i], err, 'get', axiosOptions, null, options)
            didError = true
          }
        }
      }
      if (!didError) {
        _error(options[0], err, 'get', axiosOptions, null, options)
      }
    })
  }

  /**
   * Release locks
   */
  function _release (releaseCallback = () => {}, options) {
    const locks = _openRecordLocks()
    if (locks) {
      _setLoading(options)
      console.log('releaseLocks:', locks)
      _get({
        command: 'releaseLock',
        load: () => {
          _purgeRecordLock(locks)
          releaseCallback()
          _clearLoading(options)
        },
        error: () => {
          releaseCallback()
          _clearLoading(options)
        },
        params: {record_key: locks}
      })
    } else {
      // No locks
      releaseCallback()
    }
  }

  /**
   * Export / Convert data
   * @param {*} options
   * @param {*} records
   * @param {*} axiosOptions
   */
  function _export (options, data, axiosOptions, skipLoading) {
    if (!skipLoading) _setLoading(options)
    console.log('ftAPI.export', options, axiosOptions)
    var params = _buildParams(options)
    params.method = 'EXP'
    axiosOptions = _getAxiosOptions(axiosOptions, {})
    axiosOptions.params = params
    const headers = axiosOptions.headers || {}
    if (options.requestType) {
      headers['Content-Type'] = options.requestType
    }
    if (options.responseType) {
      axiosOptions.responseType = options.responseType
    }
    ftAxios.post('API', data, axiosOptions).then((response) => {
      // HTTP 200 OK received indicating no errors encountered
      _response(options, response)
    }, (err) => {
      // Error
      _error(options, err, 'export', axiosOptions, data)
    })
  }

  /**
   * Insert / Update record(s)
   * @param {*} options
   * @param {*} records
   * @param {*} axiosOptions
   */
  function _put (options, records, axiosOptions, skipLoading) {
    if (!skipLoading) _setLoading(options)
    console.log('ftAPI.put', options, records, axiosOptions)
    var params = _buildParams(options)
    params.method = 'PUT'
    axiosOptions = _getAxiosOptions(axiosOptions, {})
    axiosOptions.params = params
    ftAxios.post('API', _withArray(records), axiosOptions).then((response) => {
      // HTTP 200 OK received indicating no errors encountered
      _response(options, response)
    }, (err) => {
      // Error
      _error(options, err, 'put', axiosOptions, records)
    })
  }

  /**
   * Delete record(s)
   * @param {*} options
   * @param {*} records
   * @param {*} axiosOptions
   */
  function _delete (options, records, axiosOptions, skipLoading) {
    if (!skipLoading) _setLoading(options)
    console.log('ftAPI.delete', options, records, axiosOptions)
    var params = _buildParams(options)
    params.method = 'DELETE'
    axiosOptions = _getAxiosOptions(axiosOptions, {})
    axiosOptions.params = params
    ftAxios.post('API', _withArray(records), axiosOptions).then((response) => {
      // HTTP 200 OK received indicating no errors encountered
      _response(options, response)
    }, (err) => {
      // Error
      _error(options, err, 'put', axiosOptions, records)
    })
  }

  function _deleteWithConfirmation (options, records, axiosOptions) {
    _caller.$vPrompt({
      title: 'Delete ' + (options.name || 'Item'),
      titleIcon: 'mdi-delete-forever',
      titleIconColor: 'error',
      text: 'Are you sure?  This cannot be undone.',
      confirmText: 'Delete',
      confirmAction: function () {
        _delete(options, records, axiosOptions)
      },
      cancelAction: true
    })
  }

  function _logoutPrompt () {
    if (!_caller.$ftAC.terminal || !_caller.$ftAC.terminal.id) {
      _caller.$vPrompt({
        title: 'Logout',
        titleIcon: 'mdi-exit-to-app',
        text: 'Are you sure you want to exit ' + _caller.$ftAC.name + '?',
        confirmText: 'Logout',
        confirmAction: function () {
          _logout()
          _foreteesLogin()
        },
        cancelAction: true
      })
    } else {
      // Logging out of a terminal is like shutting it down, until we come up with another way
      _caller.$vPrompt({
        title: 'Shut Down Terminal',
        titleIcon: 'mdi-power',
        text: 'Are you sure you want to shut down this ' + _caller.$ftAC.name + ' terminal?',
        confirmText: 'Shut Down',
        confirmAction: function () {
          _logout()
          _foreteesLogin()
        },
        cancelAction: true
      })
    }
  }

  function _sessionExpirationPrompt () {
    console.warn('Session Expired')
    if (sessionExpPromptOpen) return
    sessionExpPromptOpen = true
    _clearApiAccessToken()
    _caller.$vPrompt({
      modal: true,
      title: 'Session Has Expired',
      text: 'Sorry, your session has expired or you are not logged in.',
      confirmAction: function () {
        sessionExpPromptOpen = false
        _foreteesLogin()
      }
    })
  }

  function _foreteesLogin () {
    window.location = _loginUri()
  }

  function _logout () {
    _clearApiAccessToken()
    currentUser = getEmptyUser()
    setUser(_caller.$store, currentUser)
  }

  function _appConfigCommand () {
    return {
      command: 'appConfiguration',
      params: {
        include_fields: ['club', 'clubFullName', 'logoUrlLight', 'logoUrlDark', 'terminal'],
        filter_methods: {filterAppMode: [_appMode()], filterTerminal: [_getGlobalAppState().key]}
      },
      load: response => {
        const appConfig = response.length > 0 && response[0] || {}
        document.title = appConfig.name
        setAppConfig(_caller.$store, appConfig)
        _checkMenu(appConfig)
        builtMenu = true
      }
    }
  }

  function _clubSettingCommand () {
    return {
      command: 'clubSettingDefault',
      load: (data) => {
        console.log('Updating club settings', data)
        const clubSettings = {}
        for (let setting of data) {
          var value = setting.clubValue
          if (value !== null) {
            switch (setting.valueType) {

            case 'INTEGER':
            case 'LONG':
              value = parseInt(value, 10)
              break

            case 'DOUBLE':
            case 'FLOAT':
              value = parseFloat(value)
              break

            case 'BOOLEAN':
            case 'YES_NO':
              value = value === 'true'
              break

            case 'DATE':
            case 'DATE_TIME':
              value = new moment(value)
              break

            case 'TIME':
              value = new moment(value, 'HH:mm:ss')
              break

            default:
              if (setting.valueType.startsWith('MAP') || setting.valueType.startsWith('MULTI')) {
                try {
                  value = JSON.parse(value)
                } catch (e) {
                  console.warn('Error Parsing Json for setting: ' + setting.name, setting.clubValue)
                  value = null
                }
              }
            }
            clubSettings[setting.name] = value
          }
        }
        setClubSettings(_caller.$store, clubSettings)
        requestClubSettingsRefresh(_caller.$store, false)
        console.log('Club Setting Loaded', _clubSettings())
      },
      params: {
        filter: [{field: 'name', operator: 'IN', values: _clubSettingKeys()}],
        only_fields: ['name', 'clubValue', 'valueType'],
        skip_on_na: true
      }
    }
  }

  /**
   * Check if an SUAK login was requested, and process if so
   */
  function _checkSkLogin () {
    if (_caller.$route.query.sk) {
      // Login using single use access key
      _setSkipResponseToken(false)
      setLoggingIn(_caller.$store, true)
      _skLogin(_caller.$route.query.sk, {
        onLogin: (userRecord) => {
          // Remove ?sk= from uri
          _setSkipResponseToken(false)
          _setGlobalAppState({screenLocked: false, userLock: false})
          setLoggingIn(_caller.$store, false)
          const query = Object.assign({}, _caller.$route.query)
          delete query.sk
          console.error('Redirecting after login', query)
          _caller.$router.replace({query: query})
        }})
      return true
    } else {
      return false
    }
  }

  // Logon using single use access token
  function _skLogin (sk, options) {
    options = options || {}
    const _defaultErrorHandler = function (errorData) {
      _caller.$vPrompt({
        modal: true,
        title: 'Unable to log in',
        text: 'Unable to log in: ' + errorData.message,
        confirmAction: function () {
          _foreteesLogin()
        }
      })
    }
    options.error = options.error || _defaultErrorHandler
    if (usedSk !== sk) {
      usedSk = sk
      _clearApiAccessToken()
      _get([
        ...[_appConfigCommand()],
        {
          command: 'currentUser',
          load: function (userRecord) {
            console.warn('Login:', userRecord)
            _setUser(userRecord)
            club = userRecord.club
            if (typeof options.onLogin === 'function') {
              options.onLogin(userRecord)
            } else {
              console.warn('No onLogin handler provided')
            }
          },
          params: {addtoken: true},
          httperror: options.httperror || options.error,
          error: options.error
        },
        ...[_clubSettingCommand()]
      ],
      {headers: {'X-FtApi-SingleUseToken': sk}}
      )
    }
  }

  function _checkUser (suppressNewToken) {
    const userCommand = {
      command: 'currentUser',
      load: result => {_setUser(result)}
    }
    if (suppressNewToken) {
      userCommand.params = {snt: true}
    }
    const commands = [userCommand]
    if (_clubSettingCacheReloadRequested() || !builtMenu) {
      commands.push(_appConfigCommand())
      commands.push(_clubSettingCommand())
    }
    _get(commands)
  }

  function _setUser (userRecord) {
    currentUser = userRecord
    if (!currentUser.apps[_appMode()] || !_getApiAccessToken()) {
      // User does not have access to required mode
      setUser(_caller.$store, currentUser)
      setSessionExpired(_caller.$store, true)
      _sessionExpirationPrompt()
    } else {
      setSessionExpired(_caller.$store, false)
      if (!_caller.$ftUser || _caller.$ftUser.staffId !== userRecord.staffId) {
        // Different user
        requestClubSettingsRefresh(_caller.$store, true)
      }
      if (_caller.$ftAC.acv && currentUser.acv !== _caller.$ftAC.acv) {
        // Need to update app settings
        requestClubSettingsRefresh(_caller.$store, true)
      }
      setUser(_caller.$store, currentUser)
    }
  }

  function _currentUser () {
    return currentUser
  }

  /**
   * Private Methods
   */

  function _setLoading (options) {
    options = options || {}
    if (typeof options.loading === 'function') {
      options.loading(true, options)
    } else if (typeof _caller[options.loading] === 'boolean') {
      options.loading = true
    } else if (typeof _caller[options.loading] === 'number') {
      _caller[options.loading] += 1
    } else {
      _caller[options.loading] = true
    }
  }

  function _clearLoading (options) {
    options = options || {}
    if (typeof options.loading === 'function') {
      options.loading(false, options)
    } else if (typeof options.loading === 'string') {
      if (typeof _caller[options.loading] === 'boolean') {
        options.loading = false
      } else if (typeof _caller[options.loading] === 'number') {
        _caller[options.loading] -= 1
      }
      _caller[options.loading] = false
    }
  }
  /*
  function _stringifyParms (params) {
    return queryString.stringify(params)
  }
  */
  function _buildParams (options, method, forPost) {
    var params = {command: options.command, httperrors: true}
    if (method) {
      params.method = method
    }
    var optParams = options.params
    if (optParams) {
      for (var param in optParams) {
        var paramVal = optParams[param]
        if (typeof paramVal === 'function') paramVal = paramVal(params) // value is a callback.  call it to get our value
        if (!forPost && typeof paramVal === 'object') paramVal = JSON.stringify(paramVal) // value is an object, encode it
        params[param] = paramVal
      }
    }
    return params
  }

  function _getAxiosOptions (axiosOptions, defaultObj) {
    axiosOptions = _getObject(axiosOptions, defaultObj || {})
    if (_getApiAccessToken()) {
      axiosOptions.headers = axiosOptions.headers || {}
      axiosOptions.headers.Authorization = 'Bearer ' + _getApiAccessToken()
    }
    return axiosOptions
  }

  function _getObject (obj, defaultObj) {
    if (typeof obj === 'function') return obj()
    if (typeof obj !== 'object') return defaultObj
    return obj
  }

  function _withArray (obj) {
    if (!Array.isArray(obj)) return [obj]
    return obj
  }

  function _setAccessTokenFromResponse (ftresponse) {
    const skipTime = _getSkipResponseToken()
    // Update access token from response if we're not currently set to skip doing so
    if (!skipTime || Date.now() >= skipTime) _setAccessToken(ftresponse.jwt)
  }

  function _setAccessToken (newAccessToken) {
    if (newAccessToken) {
      if (newAccessToken === _getApiAccessToken()) {
        // console.log('JWT Has Not Changed', newAccessToken)
        // _setApiAccessToken(newAccessToken)
      } else {
        console.warn('New Access Token', newAccessToken)
        _setApiAccessToken(newAccessToken)
      }
    }
  }

  /**
   * Record Open Record Locks
   * @param {*} recordType
   * @param {*} record
   */
  function _recordRecordLock (ftresponse) {
    if (Array.isArray(ftresponse.locked)) {
      for (let recordLockKey of ftresponse.locked) {
        _callerRecordLocks[recordLockKey] = true
        recordLocks[recordLockKey] = true
      }
      _checkRecordLocks()
    }
  }

  function _openRecordLocks () {
    var locks = []
    for (var key in _callerRecordLocks) {
      locks.push(key)
    }
    return locks.length ? locks : null
  }

  function _checkRecordLocks () {
    // TODO: Implement local storage tracking of record locks via timers
    //       so app instances in other tabs do not lock screens and record locks
    _setGlobalAppState({allowScreenLock: !_openRecordLocks()})
  }

  /**
   * Remove recorded record locks for records that have released their locks
   * @param {*} recordType
   * @param {*} record
   */
  function _purgeRecordLock (record) {
    if (Array.isArray(record)) {
      for (var i in record) {
        _purgeRecordLock(record[i])
      }
      _checkRecordLocks()
    } else if (typeof record === 'object') {
      _purgeRecordLockByKey(record.releasedRecordLockKey)
    } else if (typeof record === 'string') {
      _purgeRecordLockByKey(record)
    }
  }

  function _purgeRecordLockByKey (key) {
    if (key) {
      delete recordLocks[key]
      delete _callerRecordLocks[key]
    }
    _checkRecordLocks()
  }

  function _response (options, response) {
    const headers = response.headers
    const contentType = headers['content-type'] || ''
    const isJson = !!contentType.match(/\/json/i)
    const ftresponse = isJson ? response.data : {}
    var result = isJson ? ftresponse.result : response.data
    const metadata = ftresponse.metadata
    const releasedRecordLocks = ftresponse.released
    const systemTime = ftresponse.system_time
    const newCacheKey = ftresponse.ck
    if (newCacheKey !== _clubSettingCacheKey()) {
      console.warn('Need to update club settings cache', newCacheKey)
      setClubSettingsCacheKey(_caller.$store, newCacheKey)
      requestClubSettingsRefresh(_caller.$store, true)
    }
    apiVersion = ftresponse.v || apiVersion
    if (!result && isJson && ftresponse.method === 'PUT' && ftresponse.results) {
      result = ftresponse.results[options.command]
    }
    _setAccessTokenFromResponse(ftresponse)
    if (systemTime) {
      // TODO: set server offset to min of serverTimeOffset, unless serverTimeOffset is way off from last.
      var clientTime = Math.floor(new Date().getTime() / 1000)
      serverTimeOffset = clientTime - systemTime
      clubZoneId = ftresponse.club_zone_id
    }
    if (ftresponse.method === 'PUT' || ftresponse.method === 'DELETE') {
      if (ftresponse.modified) {
        console.log(ftresponse.method + ' success, record modified')
      } else {
        console.log(ftresponse.method + ' success, but no changes')
      }
    }
    // Deal with any record locks
    _recordRecordLock(ftresponse)
    if (releasedRecordLocks) {
      _purgeRecordLock(releasedRecordLocks)
    }
    const __loadData = () => {
      // result = deepClone(result)
      if (typeof options.resultFilter === 'function') {
        // Filter result before loading it
        result = options.resultFilter.call(_caller, result)
      }
      if (typeof options.beforeLoad === 'function') {
        // let function deal with data
        options.beforeLoad.call(_caller, result, ftresponse, metadata, options)
      }
      var loader = options.load
      if (typeof loader === 'object') {
        console.log('Setting API Response: ' + (options || {}).command, result, options, ftresponse)
        // set data
        if (Array.isArray(loader)) {
          // Clear existing array
          loader.length = 0
          // Fill array
          if (Array.isArray(result)) {
            // All all results to array
            for (var i in result) {
              loader.push(result[i])
            }
            if (result.length < 1) {
              loader.pop() // Force Vue to react to change
            }
          } else {
            // Add single result to array
            loader.push(result)
          }
        } else {
          // Fill object
          var field
          var singleResult
          if (Array.isArray(result)) {
            if (result.length > 0) {
              singleResult = result[0]
            } else {
              singleResult = {}
            }
          } else {
            singleResult = result
          }
          for (field in singleResult) {
            _caller.$set(loader, field, singleResult[field])
          }
          for (field in loader) {
            if (singleResult[field] === undefined) {
              _caller.$set(loader, field, null)
            }
          }
        }
      } else if (typeof loader === 'function') {
        // let function deal with data
        console.log('Loading API Response: ' + (options || {}).command, result, options)
        loader.call(_caller, result, ftresponse, metadata, options)
      }
      if (typeof options.afterLoad === 'function') {
        // let function deal with data
        options.afterLoad.call(_caller, result, ftresponse, metadata, options)
      }
      // Delay clearing of loading flag to allow any watchers to fire first
      setTimeout(() => {_clearLoading(options)}, 0)
    }
    const notifications = ftresponse.notifications
    if (notifications && notifications.length) {
      const __displayNotification = () => {
        const notification = notifications.shift()
        if (notification) {
          const icon = notificationIcons[notification.type] || icon.default
          _caller.$vPrompt({
            modal: true,
            weakModal: true,
            width: 400,
            divider: true,
            title: notification.title,
            titleIcon: icon.icon,
            titleIconColor: icon.color,
            apiMessages: notification.messages,
            checkApiMessageLink: _caller.checkApiMessageLink || _caller.$root.checkApiMessageLink,
            doApiMessageLink: _caller.doApiMessageLink || _caller.$root.doApiMessageLink,
            setApiMessageClass: _caller.setApiMessageClass || _caller.$root.setApiMessageClass,
            confirmAction: (dialog) => {
              dialog.close()
              __displayNotification()
            }
          })
        } else {
          __loadData()
        }
      }
      __displayNotification()
    } else {
      __loadData()
    }
  }

  function _ftErrorResponse (err) {
    var response = err.response
    var ftresponse = response ? response.data : null
    if (ftresponse && ftresponse.error) {
      return ftresponse
    }
    return null
  }

  function _error (options, err, calltype, axiosOptions, records, multiOptions) {
    // some type of error has occured
    options = options || {}
    var ftresponse = _ftErrorResponse(err)
    if (ftresponse) {
      // ForeTees API error resopnse
      var responseCode = ftresponse.error_code
      if (responseCode === 401) {
        // Not authenticated
        _sessionExpirationPrompt()
      }
      if (responseCode === 403) {
        // Access to requested resource forbidden
        console.warn('API Command Access Denied', err, options)
        var user = ftresponse.current_user || {}
        var apps = user.apps || {}
        if (!apps[_appMode()]) {
          // Not a user of this app
          console.warn('Session expired', err, options)
          _sessionExpirationPrompt()
        }
      }

      // Refresh access token if a new one was sent
      _setAccessTokenFromResponse(ftresponse)

      var showError = true

      const __handleError = () => {
        // Handle any field errors
        var fieldErrors = ftresponse.field_errors
        if (fieldErrors) {
          var fieldErrorHandler = options.fieldError
          if (typeof fieldErrorHandler === 'function') {
            console.log('Setting field errors with method')
            for (var i in fieldErrors) {
              var fieldError = fieldErrors[i]
              if (fieldErrorHandler(fieldError, ftresponse)) {
                showError = false
              }
            }
          } else {
            console.warn('No field error handler found')
          }
        }

        // If no field errors were handled, handle global error
        if (showError || [400, 500, 423].indexOf(responseCode) > -1) {
          ftresponse.message = ftresponse.error // Temp. work-around for call
          let errorHandler = options.error || options.httperror
          if (typeof errorHandler === 'function') {
            errorHandler(ftresponse)
          } else {
            console.warn('No API error handler found')
          }
        }

        // Record locked error.  Tried to get a lock, but record was locked by another
        if ([423].indexOf(responseCode) > -1) {
          let errorHandler = options.lockFault
          if (typeof errorHandler === 'function') {
            errorHandler(ftresponse)
          } else {
            console.warn('No Record Lock Fault error handler found', options)
          }
        }

        console.log('FTAPI Error - loadData(' + options.command + ')', ftresponse)
        _clearLoading(options)

        var submitCancelledHandler = options.cancelled
        if (typeof submitCancelledHandler === 'function') {
          console.log('Calling submit cancelled handler')
          submitCancelledHandler(ftresponse)
        }
      }

      const prompts = ftresponse.prompts

      if (responseCode === 449 && prompts && prompts.length) {
        const fullOptions = multiOptions || options
        fullOptions.params = fullOptions.params || {}
        fullOptions.params.pr = fullOptions.params.pr || {}
        const pr = fullOptions.params.pr
        const __displayPrompt = () => {
          console.log('Showing next prompt')
          const prompt = prompts.shift()
          if (prompt) {
            console.log('Showing prompt', prompt)
            const icon = notificationIcons[prompt.type] || icon.default
            _caller.$vPrompt({
              modal: true,
              weakModal: true,
              width: 500,
              divider: true,
              title: prompt.title,
              titleIcon: icon.icon,
              titleIconColor: icon.color,
              apiMessages: prompt.messages,
              isHtml: prompt.isHtml,
              confirmText: prompt.confirmText,
              promptValues: prompt.values,
              promptValue: prompt.defaultValue,
              promptInputLabel: prompt.inputLabel,
              promptInputType: prompt.inputType,
              checkApiMessageLink: _caller.checkApiMessageLink,
              doApiMessageLink: _caller.doApiMessageLink,
              setApiMessageClass: _caller.setApiMessageClass,
              confirmAction: prompt.confirmText ? (dialog) => {
                console.log('Closing Prompt')
                dialog.close()
                pr[prompt.id] = {value: dialog.promptValue}
                __displayPrompt() // Display next prompt, if any
              } : null,
              cancelText: prompt.cancelText,
              cancelAction: (dialog) => {
                dialog.close()
                // Kill all other prompts
                prompts.splice(0, prompts.length)
                // Don't show the error
                showError = false
                __handleError()
              }
            })
          } else {
            // Done with prompts
            // Try call again, with answers
            console.log('Trying call again')
            switch (calltype) {
            case 'get':
              _get(fullOptions, axiosOptions, true)
              break
            case 'put':
              _put(fullOptions, records, axiosOptions, true)
              break
            case 'delete':
              _delete(fullOptions, records, axiosOptions, true)
              break
            }
          }
        }
        __displayPrompt()
      } else {
        __handleError()
      }
    } else {
      // some other unexpected error response
      var httpErrorHandler = options.httperror || options.error
      if (typeof httpErrorHandler === 'function') {
        httpErrorHandler(err)
      } else {
        console.warn('No HTTP error handler found')
      }
      console.log('HTTP Error (unexpected) - loadData(' + options.command + ')', err)
      _clearLoading(options)
    }

  }

  function _closeDialogs () {
    const vprompt = _caller.$vPrompt({getInstance: true})
    for (let dialog of vprompt.dialogs) {
      if (dialog.showDialog && dialog.weakModal) {
        dialog.cancel()
      }
    }
  }
}

export default {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install (Vue, options = {}) {

    // Add $ftAPI instance and other common settings for every component
    Vue.mixin({
      computed: {
        $ftCS () {
          // Club settings (from club_settings table / ClubSettings enum -- standard settings)
          return this.$store.getters.clubSettings
        },
        $ftAC () {
          // Club configuration (from AppConfiguration.java object -- options that needed a little more computation than standard settings)
          return this.$store.getters.appConfig
        },
        $ftAS () {
          // Global App State
          return this.$store.getters.appState
        },
        $ftUser () {
          return this.$store.getters.user
        },
        $ftAccess () {
          return this.$ftUser && this.$ftUser.access || {}
        },
        $ftStyle () {
          return this.$store.getters.styles
        },
        $ftAppIsDark () {
          return this.$ftStyle.appMode === 'dark'
        },
        $ftCurrentTheme () {
          return this.$vuetify.theme.themes[this.$ftAppIsDark ? 'dark' : 'light']
        },
        $ftDialogHeaderClass () {
          return {
            'headline': true,
            'grey lighten-3': !this.$ftAppIsDark,
            'grey darken-4': this.$ftAppIsDark
          }
        },
      },
      methods: {
        $ftAPI () {
          var _ftAPI = apiInstanceMap.get(this)
          if (_ftAPI) return _ftAPI
          _ftAPI = this.$ftAPIFactory(options)
          apiInstanceMap.set(this, _ftAPI)
          return _ftAPI
        },
        $ftPrettyDate (date) {
          return moment(date, 'YYYY-MM-DD').format('MM-DD-YYYY')
        },
        $ftPrettyTime (time) {
          if (time.length < 10) time = '2018-01-01 ' + time
          return moment(time).format('hh:mm A')
        }
      }
    })

    // define all global variables and methods here
    // they can be accessed in any Vue component with this.$variableName
    Vue.prototype.$ftAPIFactory = _factory
  }
}
